import { SubjectListPage } from './SubjectListPage';
export default SubjectListPage;
